var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchantIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#7529D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 14.25H17.25C16.6533 14.25 16.081 14.4871 15.659 14.909C15.2371 15.331 15 15.9033 15 16.5V19.5C15 19.6989 15.079 19.8897 15.2197 20.0303C15.3603 20.171 15.5511 20.25 15.75 20.25C16.2598 20.2491 16.7492 20.0501 17.115 19.695C17.3025 19.53 17.3475 19.5 17.505 19.5C17.6625 19.5 17.7 19.5 17.8875 19.695C18.2533 20.0501 18.7427 20.2491 19.2525 20.25C19.7629 20.2523 20.2535 20.0528 20.6175 19.695C20.8125 19.53 20.85 19.5 21.0075 19.5C21.165 19.5 21.2025 19.5 21.39 19.695C21.7554 20.0505 22.2452 20.2494 22.755 20.2494C23.2648 20.2494 23.7546 20.0505 24.12 19.695C24.3075 19.53 24.345 19.5 24.5025 19.5C24.66 19.5 24.6975 19.5 24.885 19.695C25.2508 20.0501 25.7402 20.2491 26.25 20.25C26.4489 20.25 26.6397 20.171 26.7803 20.0303C26.921 19.8897 27 19.6989 27 19.5V16.5C27 15.9033 26.7629 15.331 26.341 14.909C25.919 14.4871 25.3467 14.25 24.75 14.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26.25H26.25V21.75C25.73 21.7529 25.2165 21.6348 24.75 21.405V23.25H17.25V21.405C16.7835 21.6348 16.27 21.7529 15.75 21.75V26.25H15C14.8011 26.25 14.6103 26.329 14.4697 26.4697C14.329 26.6103 14.25 26.8011 14.25 27C14.25 27.1989 14.329 27.3897 14.4697 27.5303C14.6103 27.671 14.8011 27.75 15 27.75H27C27.1989 27.75 27.3897 27.671 27.5303 27.5303C27.671 27.3897 27.75 27.1989 27.75 27C27.75 26.8011 27.671 26.6103 27.5303 26.4697C27.3897 26.329 27.1989 26.25 27 26.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIncome);
export default __webpack_public_path__ + "static/media/merchant_income.4ffd52daa7eab09f5c6e8a48f3214023.svg";
export { ForwardRef as ReactComponent };